<script>
  let { icon = 'fa-inbox', title, message = null, children = null } = $props();
</script>

<div class="p-card flex flex-col items-center px-6 py-14 text-center">
  <i class="fas {icon} text-2xl p-faint" aria-hidden="true"></i>
  <h2 class="mt-3 text-sm font-semibold">{title}</h2>
  {#if message}<p class="mt-1 max-w-sm text-sm p-muted">{message}</p>{/if}
  {#if children}<div class="mt-4">{@render children()}</div>{/if}
</div>
